interface Props {
  percentage: number;
  size?: number;
  color?: string;
}

export default function CourseProgressRing({
  percentage,
  size = 120,
  color = 'var(--secondary, #00A86B)',
}: Props) {
  const strokeWidth = size * 0.1;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (Math.min(Math.max(percentage, 0), 100) / 100) * circumference;
  const center = size / 2;

  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        width: size,
        height: size,
      }}
    >
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        style={{ transform: 'rotate(-90deg)' }}
      >
        {/* Background track */}
        <circle
          cx={center}
          cy={center}
          r={radius}
          fill="none"
          stroke="var(--border, #4A4A4A)"
          strokeWidth={strokeWidth}
        />
        {/* Progress arc */}
        <circle
          cx={center}
          cy={center}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          style={{ transition: 'stroke-dashoffset 0.6s ease' }}
        />
      </svg>
      {/* Center label */}
      <div
        style={{
          position: 'absolute',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <span
          style={{
            fontSize: size * 0.25,
            fontWeight: 700,
            color: 'var(--text-primary, #FFFFFF)',
            lineHeight: 1,
          }}
        >
          {Math.round(percentage)}%
        </span>
        <span
          style={{
            fontSize: size * 0.1,
            color: 'var(--text-muted, #999999)',
            marginTop: 2,
          }}
        >
          complete
        </span>
      </div>
    </div>
  );
}
